import { RadioGroup } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { useThemeContext } from '@festina-life/ui/theme'

export function DarkModeSwitcher() {
  const translate = useTranslate()
  const { theme, setTheme, themeOptions } = useThemeContext()

  return (
    <RadioGroup
      options={themeOptions}
      value={theme}
      onChange={setTheme}
      wrapperProps={{ label: translate('darkModeSwitcher.label') }}
    />
  )
}
